import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal-form-container" }
const _hoisted_2 = {
  ref: "modalContent",
  class: "w-full h-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", { class: "modal-form-container-header border-b border-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "flex items-center modal-form-container-header-title" }, "견적 문의하기")
], -1)
const _hoisted_4 = { class: "modal-form-container-content text-xs md:text-md" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-placeholder mb-10 leading-4" }, "해당 모델 및 견적을 검토 후 입력하신 연락처로 연락드리겠습니다.", -1)
const _hoisted_6 = { class: "flex itmes-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-32 mt-4 text-desc" }, "성함", -1)
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_10 = {
  key: 0,
  class: "cs-feedback cs-feedback-error"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-sr-comment-exclamation" }, null, -1)
const _hoisted_12 = { class: "flex itmes-center mt-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-32 mt-4 text-desc" }, "소속", -1)
const _hoisted_14 = { class: "w-full" }
const _hoisted_15 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_16 = {
  key: 0,
  class: "cs-feedback cs-feedback-error"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-sr-comment-exclamation" }, null, -1)
const _hoisted_18 = { class: "flex itmes-center mt-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-32 mt-4 text-desc" }, "이메일", -1)
const _hoisted_20 = { class: "w-full" }
const _hoisted_21 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_22 = {
  key: 0,
  class: "cs-feedback cs-feedback-error"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-sr-comment-exclamation" }, null, -1)
const _hoisted_24 = { class: "flex itmes-center mt-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "flex w-32 mt-4 text-desc" }, "연락처", -1)
const _hoisted_26 = { class: "w-full" }
const _hoisted_27 = {
  class: "cs-form flex w-full",
  "data-height": "md"
}
const _hoisted_28 = {
  key: 0,
  class: "cs-feedback cs-feedback-error"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fi fi-sr-comment-exclamation" }, null, -1)
const _hoisted_30 = { class: "flex items-center mt-10" }
const _hoisted_31 = ["checked"]
const _hoisted_32 = { class: "modal-form-container-footer" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "취소", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "확인", -1)

import {CommonStore} from "../../store/common-store";
import {EstimateStore} from "../../store/estimate-store";
import {ModelStore} from "../../store/model-store";


import {ref, computed, defineComponent, onMounted} from "vue";
import LoaderButton from "../../components/LoaderButton.vue";
import {EstimateSubmit} from "../../js/interface";
import {validateEmail} from "../../js/utils";

const __default__ = defineComponent({
  name: "ModalClientSubmit",
  components: {
    LoaderButton,
  },
  methods: {},
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let isEnableSubmit = ref(false);
let isTerm = ref(false);

let errMsgName = ref("");
let errMsgCompany = ref("");
let errMsgEmail = ref("");
let errMsgPhone = ref("");

let name = ref("");
let company = ref("");
let email = ref("");
let phone = ref("");

const validateName = (e: any) => {
  var pattern1 = /[~!@#$%^&*+|<>?:{}]/;
  errMsgName.value = "";
  if (pattern1.test(e.target.value)) {
    errMsgName.value = "특수문자는 포함할 수 없습니다.";
  } else if (1 >= e.target.value.length) {
    errMsgName.value = "이름은 2자 이상이어야 합니다.";
  }

  validateSubmit();
};

const validateCompany = (e: any) => {
  errMsgCompany.value = "";
  if (1 >= e.target.value.length || 32 <= e.target.value.length) {
    errMsgCompany.value = "소속은 2자 이상 31자 이하 입니다.";
  }

  validateSubmit();
};

const onValidateEmail = (e: any) => {
  errMsgEmail.value = validateEmail(e.target.value);
  validateSubmit();
};

const validatePhone = (e: any) => {
  phone.value = phone.value
    .replace(/[^0-9]/g, "")
    .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3")
    .replace("--", "-");

  let val = e.target.value
    .replace(/[^0-9]/g, "")
    .replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3")
    .replace("--", "-");

  let pattern1 = /^01([0|1|2|3|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;
  let pattern2 = /^(0(2|3[1-3]|4[1-4]|5[1-5]|6[1-4]))-(\d{3,4})-(\d{4})$/;
  errMsgPhone.value = "";
  let result1 = !pattern1.test(val) && !pattern2.test(val);
  let result2 = 1 > val.length && 13 < val.length;

  if (result1 || result2) {
    errMsgPhone.value = "전화번호 양식과 다릅니다.";
  }

  validateSubmit();
};

const validateSubmit = () => {
  if (isTerm.value) {
    if (!errMsgName.value.length && !errMsgCompany.value.length && !errMsgEmail.value.length && !errMsgPhone.value.length) {
      if (name.value.length && company.value.length && email.value.length && phone.value.length) {
        isEnableSubmit.value = true;
        return;
      }
    }
  }

  isEnableSubmit.value = false;
};

const onCheckTerm = () => {
  isTerm.value = !isTerm.value;

  validateSubmit();
};

const onTerm = () => {
  CommonStore().showTermModal();
};
const onPolicy = () => {
  CommonStore().showPolicyModal();
};

const onClose = () => {
  CommonStore().closeModal();
};

const onSubmit = () => {
  const estimateStore = EstimateStore();
  const modelStore = ModelStore();

  const values: EstimateSubmit = {
    id: estimateStore.estimate.id,
    models: modelStore.models,
    client: {
      name: name.value,
      company: company.value,
      email: email.value,
      phone: phone.value,
    },
  };

  estimateStore.reqSubmit(values);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                class: "",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : name = $event)),
                onInput: validateName,
                type: "text",
                placeholder: "성함을 입력해주세요."
              }, null, 544), [
                [_vModelText, _unref(name)]
              ])
            ]),
            (_unref(errMsgName).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", null, _toDisplayString(_unref(errMsgName)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                class: "",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(company) ? (company).value = $event : company = $event)),
                onInput: validateCompany,
                type: "text",
                placeholder: "소속을 입력해주세요."
              }, null, 544), [
                [_vModelText, _unref(company)]
              ])
            ]),
            (_unref(errMsgCompany).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", null, _toDisplayString(_unref(errMsgCompany)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                class: "",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(email) ? (email).value = $event : email = $event)),
                onInput: onValidateEmail,
                type: "text",
                placeholder: "이메일을 입력해주세요."
              }, null, 544), [
                [_vModelText, _unref(email)]
              ])
            ]),
            (_unref(errMsgEmail).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", null, _toDisplayString(_unref(errMsgEmail)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _withDirectives(_createElementVNode("input", {
                class: "",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(phone) ? (phone).value = $event : phone = $event)),
                onInput: validatePhone,
                type: "text",
                placeholder: "연락처를 입력해주세요."
              }, null, 544), [
                [_vModelText, _unref(phone)]
              ])
            ]),
            (_unref(errMsgPhone).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("span", null, _toDisplayString(_unref(errMsgPhone)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("input", {
            class: "form-check-input mr-5",
            id: "term",
            type: "checkbox",
            checked: _unref(isTerm),
            onChange: onCheckTerm
          }, null, 40, _hoisted_31),
          _createElementVNode("label", { class: "form-check-label text-sm md:text-md" }, [
            _createElementVNode("a", {
              class: "text-second font-semibold",
              onClick: onTerm
            }, "서비스 이용약관"),
            _createTextVNode(" 및 "),
            _createElementVNode("a", {
              class: "text-second font-semibold",
              onClick: onPolicy
            }, "개인정보"),
            _createTextVNode(" 수집 및 처리방침 동의 ")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createVNode(LoaderButton, {
          ref: "next",
          class: "w-full cs-pd-btn-xl",
          cssButton: 'cs-btn-clear',
          onClick: onClose
        }, {
          title: _withCtx(() => [
            _hoisted_33
          ]),
          _: 1
        }, 512),
        _createVNode(LoaderButton, {
          ref: "submit",
          class: "w-full cs-pd-btn-xl",
          cssButton: 'cs-btn-base',
          isDisabled: !_unref(isEnableSubmit),
          onClick: onSubmit
        }, {
          title: _withCtx(() => [
            _hoisted_34
          ]),
          _: 1
        }, 8, ["isDisabled"])
      ])
    ], 512)
  ]))
}
}

})